import React from 'react';
import {
  Box, Typography, Button, Chip, Dialog, DialogTitle,
  DialogContent, DialogActions, CircularProgress, Alert
} from '@mui/material';
import { fDateDdMmmYyyy } from '../../utils/time';
import TenantAccountingSection from './TenantAccountingSection';

const TenantDetailsDialog = ({ open, onClose, tenant, loading, getAuthConfig }) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>Tenant Details</DialogTitle>
    <DialogContent>
      {loading ? (
        <Box display="flex" justifyContent="center" py={4}><CircularProgress /></Box>
      ) : tenant ? (
        <Box sx={{ mt: 1 }}>
          <Typography variant="body2" color="text.secondary">Status</Typography>
          <Box mb={2} mt={0.5}>
            <Chip
              label={tenant.is_active ? 'Active' : 'Suspended'}
              color={tenant.is_active ? 'success' : 'error'}
              size="small"
              variant="outlined"
            />
          </Box>

          {!tenant.is_active && (
            <Alert severity="warning" sx={{ mb: 2 }}>
              <Typography variant="body2">
                <strong>Suspended:</strong> {tenant.suspended_at ? fDateDdMmmYyyy(tenant.suspended_at) : '—'}
              </Typography>
              {tenant.suspension_reason && (
                <Typography variant="body2" mt={0.5}>
                  <strong>Reason:</strong> {tenant.suspension_reason}
                </Typography>
              )}
            </Alert>
          )}

          <Typography variant="body2" color="text.secondary">School ID (Login Code)</Typography>
          <Typography variant="body1" fontWeight={600} mb={2}>{tenant.tenant_code || tenant.id}</Typography>

          <Typography variant="body2" color="text.secondary">Internal ID</Typography>
          <Typography variant="body1" mb={2}>{tenant.id}</Typography>

          <Typography variant="body2" color="text.secondary">School Name</Typography>
          <Typography variant="body1" mb={2}>{tenant.data?.school_name || '—'}</Typography>

          <Typography variant="body2" color="text.secondary">Admin Email</Typography>
          <Typography variant="body1" mb={2}>{tenant.data?.admin_email || '—'}</Typography>

          <Typography variant="body2" color="text.secondary">Created At</Typography>
          <Typography variant="body1" mb={2}>{tenant.created_at ? fDateDdMmmYyyy(tenant.created_at) : '—'}</Typography>

          {tenant.domains?.length > 0 && (
            <>
              <Typography variant="body2" color="text.secondary">Domains</Typography>
              <Box display="flex" gap={1} flexWrap="wrap" mt={0.5}>
                {tenant.domains.map((d) => <Chip key={d.id || d.domain} label={d.domain} size="small" />)}
              </Box>
            </>
          )}

          {tenant?.id && <TenantAccountingSection tenantId={tenant.id} getAuthConfig={getAuthConfig} />}
        </Box>
      ) : null}
    </DialogContent>
    <DialogActions><Button onClick={onClose}>Close</Button></DialogActions>
  </Dialog>
);

export default TenantDetailsDialog;
